<template>
  <div class="faq home">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body">
      <div class="title boxed">
        <h2>Preguntas Frecuentes</h2>
      </div>
      <div class="boxed" role="tablist">
        <div v-if="this.$store.state.isFAQLoading == true" class="loading-container">
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>

        <b-card v-else
                no-body
                v-for="(item, index) in this.$store.state.fetchedFAQ"
                v-bind:key="`q-${index}`"
                class="mb-1">
          <b-card-header header-tag="header" :class="`p-0`" role="tab">
            <b-button block href="#" v-b-toggle="`accordion-${index}`" variant="info">{{item.q}}</b-button>
          </b-card-header>
          <b-collapse :id="`accordion-${index}`" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>{{ item.a }}</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div class="bottom-spacer"></div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Footer from "@/components/Footer";
  import FloatingLogo from "../components/FloatingLogo";
  export default {
    name: "FAQ",
    components: {
      FloatingLogo,
      Footer
    },
    data() {
      return {
        text: ``
      };
    },
    created () {
      this.routeChanged()
    },
    watch: {
      '$route': function (id) {
        this.routeChanged()
      }
    },
    methods: {
      routeChanged: function() {
        console.log("Fetching FAQ...")
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.FETCH_FAQ,
          value: null
        });
      }
    }
  };
</script>
